import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  email: string;
  uiStatus = 'login';
  errorMessage: string = null;

  private subs = new SubSink();

  constructor(
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    localStorage.clear();
    this.subs.add(
      this.activatedRoute.params.subscribe(params => {
        this.errorMessage = params.msg || null;
      })
    );
  }

  tryAgain() {
    this.uiStatus = 'login';
    this.email = null;
  }

  login() {
    this.errorMessage = null;

    if (_.isNil(this.email)) {
      this.errorMessage = 'โปรดกรอกข้อมูลให้ครบถ้วน';
      return;
    }

    this.uiStatus = 'loading';
    this.subs.add(
      this.authService.requestOtp(this.email).subscribe(
        response => {
          this.uiStatus = 'succeed';
        },
        error => {
          if (error != null && error.status === 400) {
            this.uiStatus = 'failed';
            this.errorMessage = error.error.detail;
          }
        }
      )
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.ts